<template>
  <svg
    height="20px"
    style="enable-background: new 0 0 20 20"
    version="1.1"
    viewBox="0 0 512 512"
    width="512px"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="comp_x5F_335-telegram">
      <g>
        <path
          class="icon-fill"
          d="M484.689,98.231l-69.417,327.37c-5.237,23.105-18.895,28.854-38.304,17.972L271.2,365.631l-51.034,49.086    c-5.647,5.647-10.372,10.372-21.256,10.372l7.598-107.722L402.539,140.23c8.523-7.598-1.848-11.809-13.247-4.21L146.95,288.614    L42.619,255.96c-22.694-7.086-23.104-22.695,4.723-33.579L455.423,65.166C474.316,58.081,490.85,69.375,484.689,98.231z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "telegram",
};
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>
